import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { Box, List } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';
import { CardTitleTypography } from 'components/styles_components/typography';
import { StyledLink } from 'components/styles_components/link';
import { useError } from 'contexts/error';
import { PlacesLink } from 'utils/link';
import PlacesQuery from 'queries/place/index';
import ListItem from 'components/place/index/list_item';
import ListHeader from 'components/place/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const PlacesAttention = () => {
  const setError = useError();
  const { data = { places: { places: [], placesTotalPages: 1 } }, loading, error } = useQuery(
    PlacesQuery,
    {
      variables: {
        bucket: 'overdue',
        page: 1,
      },
      fetchPolicy: 'cache-and-network',
      onError: () => {
        setError('error.place.index');
      },
    }
  );

  const places = data.places.places;
  const hasMore = data.places.placesTotalPages > 1;

  return (
    <WhiteCard>
      <LoaderContainer loading={loading} error={error} wrap={false}>
        <CardTitleTypography variant="h5">
          <FormattedMessage id="dashboard.places_attention.title" />
        </CardTitleTypography>
        {places.length === 0 ? (
          <InfoContainer visible>
            <FormattedMessage id="dashboard.places_attention.empty" />
          </InfoContainer>
        ) : (
          <>
            <List>
              <ListHeader />
              {places.map((place) => (
                <ListItem key={place.id} place={place} />
              ))}
            </List>
            {hasMore && (
              <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                <StyledLink to={PlacesLink()}>
                  <FormattedMessage id="dashboard.places_attention.show_more" />
                </StyledLink>
              </Box>
            )}
          </>
        )}
      </LoaderContainer>
    </WhiteCard>
  );
};

export default PlacesAttention;
